/**
 * 清理手機條碼後 7 碼輸入：英文轉大寫、僅保留合規字元（數字、大寫英文、. + -）。
 * 逐字攔截不合規字元（小寫經轉大寫後保留、全形/空白/符號/「/」前綴一律移除），不限制長度。
 * 完整格式驗證見 validatePhoneCarrierNumber。
 */
const ALLOWED_CARRIER_CHARS = /[^0-9A-Z.+-]/g

export const sanitizePhoneCarrierInput = (rawInput: string): string =>
  rawInput.toUpperCase().replace(ALLOWED_CARRIER_CHARS, '')
